<div class="aya-price-list-links">
  <lx-price-lists-portal-application-form [company]="company" [applicationForms]="applicationForms"></lx-price-lists-portal-application-form>
  <lx-price-lists-portal-price-lists-popup title="Terms & Conditions" [company]="company">
    <lx-price-lists-portal-terms-and-conditions [company]="company"></lx-price-lists-portal-terms-and-conditions>
  </lx-price-lists-portal-price-lists-popup>
  <lx-price-lists-portal-price-lists-popup title="Supplementary Options" [company]="company">
    <lx-price-lists-portal-aya-supplements [supplements]="supplements"></lx-price-lists-portal-aya-supplements>
  </lx-price-lists-portal-price-lists-popup>
  <lx-price-lists-portal-price-lists-popup title="Public Holidays" [company]="company">
    <lx-price-lists-portal-public-holidays [countryCode]="countryCode"></lx-price-lists-portal-public-holidays>
  </lx-price-lists-portal-price-lists-popup>
  <lx-price-lists-portal-price-lists-popup title="Program Dates" [company]="company">
    <lx-price-lists-portal-aya-program-dates [programDatesBySchool]="programDates"></lx-price-lists-portal-aya-program-dates>
    <lx-price-lists-portal-aya-session-breaks [sessionBreaksBySchool]="sessionBreaks"></lx-price-lists-portal-aya-session-breaks>
  </lx-price-lists-portal-price-lists-popup>
</div>
